import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import imageCompression from 'browser-image-compression';
import api from '../../services/api';

export default function MobileCamera() {
  const { sessionId } = useParams(); // Pega o ID da sessão que veio no QR Code
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);

  // Função que roda assim que você tira a foto no celular
  const handleCapture = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    
    setLoading(true);
    try {
      // Pega a imagem tirada
      let file = files[0];
      
      // Comprime a imagem no próprio celular pra enviar bem rápido pro servidor
      const options = { maxSizeMB: 1, maxWidthOrHeight: 1280, useWebWorker: true };
      const compressedFile = await imageCompression(file, options);

      // Converte pra Base64 pra enviar fácil
      const reader = new FileReader();
      reader.readAsDataURL(compressedFile);
      reader.onloadend = async () => {
        const base64data = reader.result;

        // POST para a API (Envia para aquela sessão específica do QR Code)
        await api.post('/ordens-servico/api/sync-camera', {
           sessionId: sessionId,
           image: base64data
        });

        setEnviado(true);
        setLoading(false);
        
        // Depois de 3 seg, permite tirar outra foto
        setTimeout(() => setEnviado(false), 3000);
      };
    } catch (error) {
      console.error(error);
      alert("Erro ao enviar foto. Tente novamente.");
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', textAlign: 'center', fontFamily: 'sans-serif', backgroundColor: '#0f172a', height: '100vh', color: '#fff', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      
      <h2 style={{margin: 0, marginBottom: '10px'}}>Envio de Anexos</h2>
      <p style={{color: '#94a3b8', fontSize: '14px', marginBottom: '40px'}}>As fotos tiradas aqui aparecerão instantaneamente no computador.</p>
      
      {loading ? (
         <div style={{ color: '#38bdf8', fontWeight: 'bold' }}>Enviando para o computador... aguarde.</div>
      ) : enviado ? (
         <div style={{ color: '#10b981', fontWeight: 'bold', fontSize: '20px' }}>✅ Foto Enviada!</div>
      ) : (
         <label style={{
            display: 'inline-block',
            backgroundColor: '#4F46E5',
            color: '#fff',
            padding: '20px 40px',
            borderRadius: '50px',
            fontSize: '18px',
            fontWeight: 'bold',
            cursor: 'pointer',
            boxShadow: '0 10px 15px -3px rgba(79, 70, 229, 0.4)'
         }}>
           📸 ABRIR CÂMERA
           {/* MÁGICA AQUI: O capture="environment" força abrir a câmera traseira do celular */}
           <input 
              type="file" 
              accept="image/*" 
              capture="environment" 
              onChange={handleCapture} 
              style={{ display: 'none' }} 
           />
         </label>
      )}
      
      <p style={{marginTop: '40px', fontSize: '12px', color: '#475569'}}>Sessão: {sessionId}</p>
    </div>
  );
}